module.exports = __webpack_public_path__ + "media/assets/illustrations/dtc-logo-04572f7da6ec1d863b2796b1f86e7fd2.svg";